export enum DataSource {
	IndexedDB = "indexedDB",
	Backend = "backend",
}
